import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';

const AssignModule = (props) => {
    const { modules } = props.data;
    const { previouslyMappedModules, handleSubmit } = props
    const [permissions, setPermissions] = useState([])

    useEffect(() => {
        setPermissions(previouslyMappedModules)
    }, [previouslyMappedModules])

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-nowrap table-hover">
                    <thead className="table-light">
                        <tr>
                            <th scope="col" style={{ width: 70 }}>
                                #
                            </th>
                            <th scope="col">Module Name</th>
                            <th scope="col">Permissions</th>

                        </tr>
                    </thead>
                    <tbody>
                        {modules.map((item, index) => (
                            <tr key={item.MODULE_ID} className="align-top">
                                {/* Serial Number */}
                                <td className="fw-bold">{index + 1}</td>

                                {/* Module Name + Visibility */}
                                <td>
                                    <div className="fw-semibold fs-6">{item.MODULE_NAME}</div>
                                    <div className="text-muted small d-flex align-items-center mt-1">
                                        <span className="me-2">Visibility</span>
                                        <span className={`badge rounded-circle ${item.STATUS === 'A' ? 'bg-success' : 'bg-warning'} p-1`}>
                                            <span className="visually-hidden" />
                                        </span>
                                    </div>
                                </td>

                                {/* Permissions in neat flex wrap */}
                                <td style={{ minWidth: '500px' }}>
                                    <div className="container-fluid p-0">
                                        <div className="row">
                                            {item.permissions?.map((perm, permIndex) => (
                                                <div className="col-md-4 mb-2" key={permIndex}>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`perm_${item.MODULE_ID}_${perm.PERMISSION_ID}`}
                                                            checked={permissions.some(
                                                                (p) => p.MODULE_ID === item.MODULE_ID && p.PERMISSION_ID === perm.PERMISSION_ID
                                                            )}
                                                            onChange={(e) => {
                                                                const permissionObj = {
                                                                    MODULE_ID: item.MODULE_ID,
                                                                    PERMISSION_ID: perm.PERMISSION_ID,
                                                                };

                                                                if (e.target.checked) {
                                                                    // ✅ Add if not already present
                                                                    setPermissions((prev) => [...prev, permissionObj]);
                                                                } else {
                                                                    // ❌ Remove if unchecked
                                                                    setPermissions((prev) =>
                                                                        prev.filter(
                                                                            (p) =>
                                                                                !(
                                                                                    p.MODULE_ID === permissionObj.MODULE_ID &&
                                                                                    p.PERMISSION_ID === permissionObj.PERMISSION_ID
                                                                                )
                                                                        )
                                                                    );
                                                                }
                                                            }}
                                                        />

                                                        <label className="form-check-label" htmlFor={`perm_${item.MODULE_ID}_${permIndex}`}>
                                                            {perm.PERMISSION_NAME}
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </td>


                            </tr>
                        ))}
                    </tbody>

                </table>


            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-3">
                        <button
                            type='submit'
                            className="btn btn-success waves-effect btn-label waves-light me-2"
                            onClick={() => {
                                handleSubmit(permissions)
                            }}
                        >
                            <i className="bx bx-check-double label-icon" />{" "}
                            Save
                        </button>
                        <Link
                            className="btn btn-danger waves-effect btn-label waves-light text-white"
                            to={constant.Authedcomponent.assignModules.url}
                        >
                            <i className="bx bx-block label-icon " /> Cancel
                        </Link>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AssignModule